import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
import "@stripe/stripe-js";

import Home from "./pages/Home";
import Cart from "./pages/Cart";
import { ShopContextProvider, ShopContext } from "./context/ShopContext";
import Error from "./pages/Error";
import About from "./pages/About";
import "./App.css";
import SubscriptionPrompt from "./components/SubscriptionPrompt";
import Downloads from "./pages/Downloads";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Project from "./pages/Project";
import Cork from "./pages/Cork";
import PageTracker from "./context/PageTracker";
import CartOverlay from "./components/CartOverlay";
import AllProducts from "./pages/AllProducts";
import TermsAndConditions from "./components/TermsAndConditions";
import ProductViewGrid from "./components/ProductViewGrid";
import CookiesPolicy from "./components/CookiesPolicy";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ReturnsPolicy from "./components/ReturnsPolicy";
import Delivery from "./pages/Delivery";

// A fresh product page per product. Without the key, React reuses the page
// when moving between products, so the previous product's colour index,
// quantity and add-ons carry over — e.g. Orb colour #4 then Coaster (fewer
// colours) crashed the page blank until a refresh.
function ProductRoute() {
  const { productId } = useParams();
  return <ProductViewGrid key={productId} />;
}

function App() {
  const { isCartOverlayVisible, toggleCartOverlay } = useContext(ShopContext);

  // Capture inbound attribution params once on first load so they survive
  // navigation between landing and Cart. Used by the Shopify checkout
  // hand-off in src/pages/Cart/index.js to keep gclid/utm intact across
  // the corkmatters.shop → 107h2r-79.myshopify.com domain switch.
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    [
      "gclid",
      "gbraid",
      "wbraid",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ].forEach((k) => {
      const v = sp.get(k);
      if (v) sessionStorage.setItem("attr_" + k, v);
    });
  }, []);

  return (
    <div>
      <SubscriptionPrompt />
      <Router>
        <CartOverlay
          isVisible={isCartOverlayVisible}
          closeOverlay={toggleCartOverlay}
        />
        <PageTracker />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/cancel" element={<Error />} />

          <Route path="/about" element={<About />} />
          <Route path="/product/:productId" element={<ProductRoute />} />
          <Route path="*" element={<Error />} />
          <Route path="/error" element={<Error />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/project" element={<Project />} />
          <Route path="/cork" element={<Cork />} />
          <Route path="/shop" element={<AllProducts />} />
          <Route path="/cookiespolicy" element={<CookiesPolicy />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/products/all" element={<AllProducts />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/returnspolicy" element={<ReturnsPolicy />} />
          <Route path="/delivery" element={<Delivery />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
